import { brandSlogan, brandName, heroStats, hotWords } from "@/mocks/gossip";

export default function SiteHero() {
  return (
    <section id="top" className="relative flex min-h-[720px] w-full flex-col overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20dark%20editorial%20illustration%20of%20a%20live%20streaming%20gossip%20hub%20with%20glowing%20coral%20red%20and%20hot%20pink%20neon%20lights%20on%20deep%20charcoal%20black%20background%2C%20floating%20speech%20bubbles%20and%20megaphone%20and%20camera%20icons%2C%20theater%20spotlight%20beam%20and%20popcorn%20silhouettes%2C%20crowd%20watching%20energy%2C%20flat%20vector%20art%20with%20grain%2C%20high%20contrast%2C%20dramatic%20rim%20lighting&width=1600&height=1000&seq=chigua-hero-2026-x1&orientation=landscape"
          alt="吃瓜直播热门事件围观现场氛围背景图"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/55 to-background-950"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col justify-center px-4 pb-20 pt-28 text-center md:px-6 lg:px-8">
        <p className="mx-auto inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-black/25 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50/90 backdrop-blur-sm">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
          </span>
          围观群众集合地 · 事件实时跟进中
        </p>

        <h1 className="mt-6 font-heading text-4xl leading-tight font-bold text-background-50 md:text-6xl lg:text-7xl">
          {brandName}
          <span className="mt-3 block text-2xl font-normal text-background-100 md:text-4xl">
            瓜从哪吃起？{brandSlogan}
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-sm leading-7 text-background-50/85 md:text-base md:leading-8">
          蹲后续、催更、求指路一站式搞定。热门事件入口清晰，后续更新提醒到位，跟紧大部队一起围观，不错过任何精彩片段，吃瓜体验更省心。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#hot"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-fire-line"></i>
            去看今日热门
          </a>
          <a
            href="#scene"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/35 bg-black/20 px-7 py-3.5 text-base font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/15 sm:w-auto"
          >
            <i className="ri-video-chat-line"></i>
            蹲连麦现场
          </a>
        </div>

        {/* stats */}
        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center rounded-2xl border border-background-50/15 bg-black/25 px-4 py-4 backdrop-blur-sm"
            >
              <dt className="order-2 mt-1 text-xs text-background-50/70">{s.label}</dt>
              <dd className="order-1 font-heading text-2xl font-bold text-accent-400 md:text-3xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export function HotTicker() {
  const words = [...hotWords, ...hotWords];
  return (
    <div className="relative z-10 -mt-px flex items-center overflow-hidden border-y border-background-200 bg-background-50 py-3">
      <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50">
        <i className="ri-flashlight-line"></i>
        正在围观
      </div>
      <div className="relative flex-1 overflow-hidden pl-6">
        <div className="chigua-marquee flex w-max items-center gap-8">
          {words.map((w, i) => (
            <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm font-medium text-foreground-600">
              <i className="ri-arrow-right-up-line text-primary-500"></i>
              {w}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}